import React, { useState } from 'react';

const images = [
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741715169/zl3a5d2tm05eaavbfuys.jpg',
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741714803/lea6zz4ycjgonmfpbvay.jpg',
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741714784/nkhfyxiituwmttziljvy.jpg',
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741714782/wqd7asauwayad7vuslxh.jpg',
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741714781/ywmceri6zdhhmkjsuclv.jpg',
  'https://res.cloudinary.com/dq76pknoe/image/upload/v1741714778/cws46tlxx1prda4zf6to.jpg',
];

const Gallery = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isHovering, setIsHovering] = useState(null);
  const [visibleCount, setVisibleCount] = useState(5); // Initial number of images to display

  const openImagePopup = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImagePopup = () => {
    setSelectedImageIndex(null);
  };

  const handleViewMore = () => {
    setVisibleCount((prevCount) => prevCount + 5); // Increase the number of visible images by 5
  };

  const handleViewLess = () => {
    setVisibleCount(5); // Reset to initial number of images
  };

  const goToPreviousImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div style={{ 
      maxWidth: '1400px', 
      margin: '0 auto', 
      padding: '0px', 
      backgroundColor: '#000',  
      color: '#fff',
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        fontSize: '2.5rem', 
        marginBottom: '15px', 
        color: '#fff',  
        fontWeight: '600',
        letterSpacing: '1px',
      }}>
        Our Gallery
      </h1>
      <p style={{ 
        textAlign: 'center', 
        color: '#ccc',  
        marginBottom: '30px',
        fontSize: '1.1rem',
        lineHeight: '1.6',
      }}>
        Capture the essence of your special moments with our professional services.
      </p>
      <div style={{
        borderTop: '5px solid transparent',
        backgroundImage: 'linear-gradient(to right, red, orange)',
        marginBottom: '30px',
      }}></div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '15px',
        }}
      >
        {images.slice(0, visibleCount).map((image, index) => (
          <div
            key={index}
            style={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '20px',
              boxShadow: isHovering === index 
                ? '0 8px 20px rgba(0, 0, 0, 0.2)' 
                : '0 4px 10px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
              aspectRatio: '1 / 1',
              transition: 'box-shadow 0.3s ease',
            }}
            onClick={() => openImagePopup(index)}
            onMouseEnter={() => setIsHovering(index)}
            onMouseLeave={() => setIsHovering(null)}
          >
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0)',
              transition: 'background-color 0.3s ease',
              ...(isHovering === index && { 
                backgroundColor: 'rgba(0,0,0,0.1)',
              }),
            }} />
            <img
              src={image}
              alt={`Gallery ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transform: isHovering === index ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.3s ease',
              }}
            />
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        {visibleCount < images.length ? (
          <button
            onClick={handleViewMore}
            style={{
              background: '#af1831',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              margin: '10px',
            }}
          >
            View More
          </button>
        ) : (
          <button
            onClick={handleViewLess}
            style={{
              background: '#af1831',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              margin: '10px',
            }}
          >
            View Less
          </button>
        )}
      </div>

      {selectedImageIndex !== null && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1050,
            padding: '20px',
          }}
          onClick={closeImagePopup}
        >
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '90%',
              maxHeight: '90%',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeImagePopup}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'red',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '24px',
                zIndex: 10,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                color: '#fff',
              }}
            >
              &times;
            </button>

            {/* Previous Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                goToPreviousImage();
              }}
              style={{
                position: 'absolute',
                left: '20px',
                background: 'rgba(255, 255, 255, 0.8)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '24px',
                zIndex: 10,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                color: '#000',
              }}
            >
              &#10094;
            </button>

            {/* Next Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                goToNextImage();
              }}
              style={{
                position: 'absolute',
                right: '20px',
                background: 'rgba(255, 255, 255, 0.8)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '24px',
                zIndex: 10,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                color: '#000',
              }}
            >
              &#10095;
            </button>

            {/* Selected Image */}
            <img
              src={images[selectedImageIndex]}
              alt="Selected"
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
                border: '4px solid white',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;